import { Routes, Route, Navigate } from 'react-router-dom'
import LoginPage from './pages/LoginPage'
import MainMenuPage from './pages/MainMenuPage'
import GamePage from './pages/GamePage'
import { useAuth } from './hooks/useAuth'

function RequireAuth({ children }: { children: JSX.Element }) {
  const { token } = useAuth()
  if (!token) return <Navigate to="/login" replace />
  return children
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/menu" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/menu"
        element={
          <RequireAuth>
            <MainMenuPage />
          </RequireAuth>
        }
      />
      <Route
        path="/play/:stageId"
        element={
          <RequireAuth>
            <GamePage />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
